import React from 'react';
import {Col, Flex} from "antd";
import {StorageAndDeliveryConditionPopUPCardProps} from "../../../models";
import {StyledCard} from "./StorageAndDeliveryConditionPopUp.styled";
import style from "./StorageAndDeliveryConditionsPopUp.module.scss";

const StorageAndDeliveryConditionPopUpCard = ({title,description }: StorageAndDeliveryConditionPopUPCardProps) => {

    return (
        <Flex justify={"space-around"} align={"baseline"}>
           <span style={{fontSize: "13px", textAlign: "justify"}}>
  <span style={{fontWeight: "bolder", color: "var(--primaryColor)"}}>{title}</span>
  : {description}
</span>
        </Flex>
    );
};

export default StorageAndDeliveryConditionPopUpCard;
